import Setting from '../containers/SettingContainer'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_MENU = 'GET_MENU'

// ------------------------------------
// Actions
// ------------------------------------
export function getMenu () {
  return {
    type: GET_MENU,
  }
}

export const actions = {
  getMenu
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_MENU]: (state, action) => {
    return fetchPosts().then(([response, json]) => {
      if (response.status === 200) {
        state.menuList = json
      }
    })
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  menuList: []
}
export default function headermenuReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

function fetchPosts () {
  const URL = Setting.urlApi + 'menu'
  return fetch(URL, { method: 'GET' })
        .then(response => Promise.all([response, response.json()]))
}



// WEBPACK FOOTER //
// ./src/modules/headermenu.js